import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { registerAppServiceWorker } from './lib/serviceWorkerRegistration';
import { toast } from '@/hooks/use-toast';
import { ToastAction } from '@/components/ui/toast';
import reportWebVitals from './reportWebVitals';

// Declare global __DEV__ variable
declare global {
  const __DEV__: boolean;
}

// Add global error handler for better debugging
window.addEventListener('error', (event) => {
  console.error('Global error caught:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    stack: event.error?.stack
  });
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', {
    reason: event.reason,
    promise: event.promise
  });
});

// Add better error logging for production
if (!__DEV__) {
  // Override console.error to capture more details
  const originalError = console.error;
  console.error = (...args) => {
    originalError.apply(console, args);

    // Log additional context
    if (args[0] && typeof args[0] === 'string' && args[0].includes('undefined is not a function')) {
      originalError.apply(console, ['Additional context for undefined function error:', {
        stack: new Error().stack,
        userAgent: navigator.userAgent,
        url: window.location.href,
        timestamp: new Date().toISOString()
      }]);
    }
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();

registerAppServiceWorker({
  onNeedReload: () => {
    toast({
      title: 'Update Available',
      description: 'A new version of the app is available. Click to refresh.',
      action: (
        <ToastAction altText="Refresh to update" onClick={() => window.location.reload()}>
          Refresh
        </ToastAction>
      ),
      duration: 1000000,
    });
  }
});
